<ng-container>
    <div class="voice-textarea-wrapper" [ngClass]="{ 'no-border': !showBorders }">
        <textarea
            *ngIf="showTextArea"
            #textAreaRef
            class="form-control"
            rows="3"
            [(ngModel)]="fullText"
            (input)="onTextAreaInput()"
            [attr.maxLength]="maxChars ?? null"
            placeholder="{{ 'app.wizard.stepper_ia.voice_record.prompt-placeholder' | translate }}"
        ></textarea>
        <div class="controls-row" *ngIf="!flagPlugin">
            <button
                type="button"
                class="mic-button"
                (click)="toggleRecording()"
                title="{{ 'app.wizard.stepper_ia.voice_record.buttons.start-stop' | translate }}"
            >
                <span class="mic-icon" [class.recording]="isRecording">
                    <i class="fad" [ngClass]="isRecording ? 'fa-record-vinyl' : 'fa-microphone-alt'"></i>
                </span>
                <span class="mic-text" *ngIf="isRecording">
                    {{ 'app.wizard.stepper_ia.voice_record.buttons.stop-recording' | translate }}
                </span>
            </button>

            <select
                *ngIf="!isRecording && showLanguageSelect"
                class="form-select language-dropdown"
                [(ngModel)]="selectedLanguage"
                [ngModelOptions]="{ standalone: true }"
                (change)="onLanguageChange()"
            >
                <option value="es-ES">{{ 'app.wizard.stepper_ia.voice_record.buttons.es' | translate }}</option>
                <option value="en-US">{{ 'app.wizard.stepper_ia.voice_record.buttons.en' | translate }}</option>
                <option value="fr-FR">{{ 'app.wizard.stepper_ia.voice_record.buttons.fr' | translate }}</option>
                <option value="de-DE">{{ 'app.wizard.stepper_ia.voice_record.buttons.de' | translate }}</option>
                <option value="it-IT">{{ 'app.wizard.stepper_ia.voice_record.buttons.it' | translate }}</option>
                <option value="pt-BR">{{ 'app.wizard.stepper_ia.voice_record.buttons.pt' | translate }}</option>
            </select>
        </div>
    </div>
    <small
        *ngIf="maxChars !== undefined"
        class="text-muted d-block mt-1 mr-2 char-counter"
        [class.limit-reached]="(fullText + interimText).length >= maxChars"
    >
        {{ (fullText + interimText).length }}/{{ maxChars }}
    </small>
</ng-container>
